"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Tabs/Item.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);















const TabItem = ({
  label, iconName, isSelected,
  className, onClick, badge,
}) => {
  const iconFileName = `${iconName}-${isSelected ? 'purple' : 'grey'}.svg`
  const onKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    _react2.default.createElement('div', {
      role: "tab",
      tabIndex: 0,
      'aria-selected': isSelected,
      onClick: onClick,
      onKeyDown: onKeyDown,
      className: _classBuilder2.default.call(void 0, className, isSelected && 'selected'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}

      ,  iconName && _react2.default.createElement('img', { src: `/assets/icons/tabs/${iconFileName}`, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}} ) 
      ,  label && _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 40}},  label ) 
      ,  badge && badge.count > 0 && (
        _react2.default.createElement('span', { className: "tabs--badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
          ,  badge.count 
          , _react2.default.createElement('span', { className: "visually-hidden-badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, " " ,  badge.label )
        )
      )
    )
  )
}

exports. default = TabItem
